import { createSelector, createSlice, type PayloadAction } from '@reduxjs/toolkit';

import ProductSupportConfig from '../../assets/data/ProductSupportConfig.json';
import { type Product, ProductName, type Tab } from '../../types/common.types';
import type { ProductState, RootState } from '../types';

const products = ProductSupportConfig.products as unknown as Product[];
const tabs = ProductSupportConfig.tabs as unknown as Tab[];

const initialState: ProductState = {
  selectedProductName: ProductName.TrialMax,
  products,
  tabs,
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setSelectedProduct: (state, action: PayloadAction<ProductName>) => {
      state.selectedProductName = action.payload;
    },
  },
});

export const { setSelectedProduct } = productSlice.actions;

export const selectSelectedProductName = (state: RootState) => state.product.selectedProductName;
export const selectProducts = (state: RootState) => state.product.products;
export const selectTabs = (state: RootState) => state.product.tabs;
export const selectSelectedProduct = createSelector(
  [selectSelectedProductName, selectProducts],
  (selectedName, products) => products.find((product) => product.label === selectedName) as Product
);

// Memoized selector to prevent unnecessary rerenders
export const selectSelectedProductTabs = createSelector(
  [selectSelectedProduct, selectTabs],
  (selectedProduct, tabs) => {
    return tabs.filter((tab) => tab.productcode === selectedProduct.productcode) as Tab[];
  }
);

export default productSlice.reducer;
